export const TECHOP_TABLE_COLUMN_IDS = [
  "realFarmLandName",
  "cropTypeName",
  "startDate",
  "operationNumber",
  "techOperationGroupName",
  "techOperationSubGroupName",
  "fieldSize",
  "techAssetName",
  "trailerAssetName",
  "employeeFullName",
  "createdByUserFullName",
] as const;

export type TechopTableColumnId = (typeof TECHOP_TABLE_COLUMN_IDS)[number];

export const TECHOP_TABLE_HIDDEN_BY_DEFAULT_COLUMN_IDS: readonly TechopTableColumnId[] = [
  "techAssetName",
  "trailerAssetName",
  "employeeFullName",
  "createdByUserFullName",
];

export const TECHOP_TABLE_DEFAULT_VISIBLE_COLUMN_IDS: TechopTableColumnId[] =
  TECHOP_TABLE_COLUMN_IDS.filter(
    (id) => !TECHOP_TABLE_HIDDEN_BY_DEFAULT_COLUMN_IDS.includes(id)
  );
